import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { format, symbol, normalize } from '@piconetworks/pkg-currency';
import Form from '@piconetworks/pkg-form';
import { H3 } from '@piconetworks/pkg-heading';
import style from './scss/SelectDonation.module.scss.js';
import { RemoteJsonText } from '@piconetworks/pkg-remote-markdown';

var _excluded = ["fieldContainerProps", "required", "popup", "name", "linkColor", "contrastColor", "product", "setProductOptionId", "setCustomPrice", "className", "currentPurchaseOptionId", "customFeaturesUrl", "isGroupMember", "currentSubscriptionType", "isSwitch", "contributionLanguage"];
var SelectDonation = function SelectDonation(props) {
  var _classNames3, _classNames4, _classNames5;
  var fieldContainerProps = props.fieldContainerProps;
    props.required;
    props.popup;
    props.name;
    var _props$linkColor = props.linkColor,
    linkColor = _props$linkColor === void 0 ? '' : _props$linkColor;
    props.contrastColor;
    var _props$product = props.product,
    product = _props$product === void 0 ? {} : _props$product,
    setProductOptionId = props.setProductOptionId,
    setCustomPrice = props.setCustomPrice,
    className = props.className,
    currentPurchaseOptionId = props.currentPurchaseOptionId,
    _props$customFeatures = props.customFeaturesUrl,
    customFeaturesUrl = _props$customFeatures === void 0 ? '' : _props$customFeatures,
    isGroupMember = props.isGroupMember,
    currentSubscriptionType = props.currentSubscriptionType,
    isSwitch = props.isSwitch,
    _props$contributionLa = props.contributionLanguage,
    contributionLanguage = _props$contributionLa === void 0 ? 'tip' : _props$contributionLa,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _useState = useState(0),
    monthlyDonationCustomPrice = _useState[0],
    setMonthlyDonationCustomPrice = _useState[1];
  var _useState2 = useState(0),
    yearlyDonationCustomPrice = _useState2[0],
    setYearlyDonationCustomPrice = _useState2[1];
  var _useState3 = useState(0),
    singleDonationCustomPrice = _useState3[0],
    setSingleDonationCustomPrice = _useState3[1];
  var _useState4 = useState(null),
    toggleState = _useState4[0],
    changeToggleState = _useState4[1];
  var _useState5 = useState(null),
    monthlyDonationChoice = _useState5[0],
    setMonthlyDonationChoice = _useState5[1];
  var _useState6 = useState(null),
    yearlyDonationChoice = _useState6[0],
    setYearlyDonationChoice = _useState6[1];
  var _useState7 = useState(null),
    singleDonationChoice = _useState7[0],
    setSingleDonationChoice = _useState7[1];
  var _useState8 = useState([]),
    sortedMonthlyDonations = _useState8[0],
    setSortedMonthlyDonations = _useState8[1];
  var _useState9 = useState([]),
    sortedYearlyDonations = _useState9[0],
    setSortedYearlyDonations = _useState9[1];
  var _useState10 = useState([]),
    sortedSingleDonations = _useState10[0],
    setSortedSingleDonations = _useState10[1];

  // people already on a current subscription can only make one time donations
  var isCurrentSubscriber = currentSubscriptionType && currentSubscriptionType === 'subscription';
  var onlyShowOneTimeDonations = isGroupMember || isCurrentSubscriber;
  useEffect(function () {
    getChoices();
  }, [product]);
  var title = product === null || product === void 0 ? void 0 : product.title;
  var getChoices = function getChoices() {
    var _product$options, _mappedProducts$singl, _mappedProducts$month, _mappedProducts$year, _, _2, _3;
    var mappedProducts = product === null || product === void 0 ? void 0 : (_product$options = product.options) === null || _product$options === void 0 ? void 0 : _product$options.reduce(function (productResults, _ref) {
      var id = _ref.id,
        currencyCode = _ref.currency,
        amount = _ref.price,
        type = _ref.type,
        defaultOption = _ref.default_option,
        interval = _ref.interval;
      var donationFrequency = interval || type;
      if (!productResults[donationFrequency]) {
        productResults[donationFrequency] = [];
      }
      var price = amount && format({
        currencyCode: currencyCode,
        amount: amount,
        symbol: true
      });

      // Check to see if an option with a null price already exists in productResults[type].
      var optionHasNullPrice = function optionHasNullPrice(option) {
        return option.price === null;
      };
      var addNullOption = price === null && !productResults[donationFrequency].some(optionHasNullPrice);

      // If option price is not null and productResults does not already have an option with a
      // null price value, add to productResults. This prevents display of multiple Option fields.
      if (price !== null || addNullOption) {
        productResults[donationFrequency].push({
          amount: amount,
          price: price,
          id: id,
          defaultOption: defaultOption
        });
      }
      return productResults;
    }, {});
    var sortedSingleDonations = (mappedProducts === null || mappedProducts === void 0 ? void 0 : (_mappedProducts$singl = mappedProducts['single-donation']) === null || _mappedProducts$singl === void 0 ? void 0 : _mappedProducts$singl.sort(function (_ref2, _ref3) {
      var a = _ref2.amount;
      var b = _ref3.amount;
      return a - b;
    })) || [];
    var hasSingleDonations = sortedSingleDonations.length > 0;
    hasSingleDonations && sortedSingleDonations.push(sortedSingleDonations.shift());
    var sortedMonthlyDonations = (mappedProducts === null || mappedProducts === void 0 ? void 0 : (_mappedProducts$month = mappedProducts['month']) === null || _mappedProducts$month === void 0 ? void 0 : _mappedProducts$month.sort(function (_ref4, _ref5) {
      var a = _ref4.amount;
      var b = _ref5.amount;
      return a - b;
    })) || [];
    var hasMonthlyDonations = sortedMonthlyDonations.length > 0;
    hasMonthlyDonations && sortedMonthlyDonations.push(sortedMonthlyDonations.shift());
    var sortedYearlyDonations = (mappedProducts === null || mappedProducts === void 0 ? void 0 : (_mappedProducts$year = mappedProducts['year']) === null || _mappedProducts$year === void 0 ? void 0 : _mappedProducts$year.sort(function (_ref6, _ref7) {
      var a = _ref6.amount;
      var b = _ref7.amount;
      return a - b;
    })) || [];
    var hasYearlyDonations = sortedYearlyDonations.length > 0;
    hasYearlyDonations && sortedYearlyDonations.push(sortedYearlyDonations.shift());
    var defaultOptionMonthlyDonations = sortedMonthlyDonations.filter(function (donation) {
      return donation.defaultOption;
    });
    var defaultOptionYearlyDonations = sortedYearlyDonations.filter(function (donation) {
      return donation.defaultOption;
    });
    var defaultOptionSingleDonation = sortedSingleDonations.filter(function (donation) {
      return donation.defaultOption;
    });
    setSortedMonthlyDonations(sortedMonthlyDonations);
    setSortedYearlyDonations(sortedYearlyDonations);
    setSortedSingleDonations(sortedSingleDonations);
    changeToggleState(onlyShowOneTimeDonations ? 'single-donation' : defaultOptionMonthlyDonations.length ? 'month' : defaultOptionYearlyDonations.length ? 'year' : 'single-donation');
    setMonthlyDonationChoice((_ = (defaultOptionMonthlyDonations !== null && defaultOptionMonthlyDonations !== void 0 && defaultOptionMonthlyDonations.length ? defaultOptionMonthlyDonations : sortedMonthlyDonations)[0]) === null || _ === void 0 ? void 0 : _.id);
    setYearlyDonationChoice((_2 = (defaultOptionYearlyDonations !== null && defaultOptionYearlyDonations !== void 0 && defaultOptionYearlyDonations.length ? defaultOptionYearlyDonations : sortedYearlyDonations)[0]) === null || _2 === void 0 ? void 0 : _2.id);
    setSingleDonationChoice((_3 = (defaultOptionSingleDonation !== null && defaultOptionSingleDonation !== void 0 && defaultOptionSingleDonation.length ? defaultOptionSingleDonation : sortedSingleDonations)[0]) === null || _3 === void 0 ? void 0 : _3.id);
  };
  var intendedChoice = function (_product$options2) {
    var selectedChoice = null;
    var selectedCustomPrice = null;
    var donationType = null;
    if (toggleState === 'single-donation') {
      selectedChoice = singleDonationChoice;
      selectedCustomPrice = singleDonationCustomPrice;
      donationType = 'single-donation';
    } else if (toggleState === 'month') {
      selectedChoice = monthlyDonationChoice;
      selectedCustomPrice = monthlyDonationCustomPrice;
      donationType = 'month';
    } else if (toggleState === 'year') {
      selectedChoice = yearlyDonationChoice;
      selectedCustomPrice = yearlyDonationCustomPrice;
      donationType = 'year';
    }
    if (!selectedChoice) {
      return {};
    }
    var chosenOption = product === null || product === void 0 ? void 0 : (_product$options2 = product.options) === null || _product$options2 === void 0 ? void 0 : _product$options2.find(function (_ref8) {
      var id = _ref8.id;
      return selectedChoice === id;
    });
    if (!chosenOption) {
      return {};
    }
    var id = chosenOption.id;
    var defaultOptionAmount = chosenOption.price;
    var currencyCode = chosenOption === null || chosenOption === void 0 ? void 0 : chosenOption.currency;
    var amount = chosenOption.price || selectedCustomPrice || 0;
    var symbol$1 = symbol(currencyCode);
    var price = selectedCustomPrice || format({
      currencyCode: currencyCode,
      amount: amount,
      symbol: false
    });
    return {
      id: id,
      amount: amount,
      amountFormatted: format({
        currencyCode: currencyCode,
        amount: amount,
        symbol: true
      }),
      price: "" + symbol$1 + price,
      symbol: symbol$1,
      donationType: donationType,
      currencyCode: currencyCode,
      defaultOptionAmount: defaultOptionAmount
    };
  }();
  var mapDonations = function mapDonations(_ref9) {
    var _classNames;
    var _ref9$donationsArray = _ref9.donationsArray,
      donationsArray = _ref9$donationsArray === void 0 ? [] : _ref9$donationsArray,
      _ref9$donationChoice = _ref9.donationChoice,
      donationChoice = _ref9$donationChoice === void 0 ? null : _ref9$donationChoice,
      _ref9$setDonationChoi = _ref9.setDonationChoice,
      setDonationChoice = _ref9$setDonationChoi === void 0 ? function () {} : _ref9$setDonationChoi,
      _ref9$donationName = _ref9.donationName,
      donationName = _ref9$donationName === void 0 ? '' : _ref9$donationName,
      _ref9$changeCustomPri = _ref9.changeCustomPrice,
      changeCustomPrice = _ref9$changeCustomPri === void 0 ? function () {} : _ref9$changeCustomPri;
    var filteredDonationsArray = donationsArray.filter(function (_ref10) {
      var id = _ref10.id,
        price = _ref10.price;
      return id !== currentPurchaseOptionId || !price;
    });
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(style.radioList, (_classNames = {}, _classNames[style["item-" + ((filteredDonationsArray === null || filteredDonationsArray === void 0 ? void 0 : filteredDonationsArray.length) - 1)]] = true, _classNames))
    }, filteredDonationsArray.map(function (_temp) {
      var _classNames2;
      var _ref11 = _temp === void 0 ? {} : _temp,
        id = _ref11.id,
        price = _ref11.price;
      return onlyShowOneTimeDonations && price ? null : /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          setDonationChoice(id);
        },
        key: id,
        className: classNames(style.donationOption, (_classNames2 = {}, _classNames2[style.customDonationOption] = !price, _classNames2[style.active] = id === donationChoice, _classNames2))
      }, /*#__PURE__*/React.createElement("label", null, price ? /*#__PURE__*/React.createElement("span", null, price) : /*#__PURE__*/React.createElement(Form.FormatInput, {
        label: "",
        inputPrefix: "$",
        customPrice: "true",
        symbol: false,
        className: style.customInput,
        input: {
          placeholder: '0.00',
          min: 0,
          name: 'other',
          onChange: function onChange(value) {
            if (typeof value === 'object') return false;
            var customPriceNormalized = normalize({
              currencyCode: intendedChoice.currencyCode,
              amount: value.split(',').join('')
            });
            changeCustomPrice(customPriceNormalized);
          }
        }
      })));
    }), isSwitch && donationName === 'single-donation' && /*#__PURE__*/React.createElement("small", {
      className: style.donationWarning
    }, "Please note you are making an additional one-time donation."));
  };
  var resetCustomPrice = function resetCustomPrice() {
    setMonthlyDonationCustomPrice(null);
    setYearlyDonationCustomPrice(null);
    setSingleDonationCustomPrice(null);
  };
  return /*#__PURE__*/React.createElement(Form.Field, fieldContainerProps, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: style.dflex
  }, /*#__PURE__*/React.createElement("div", {
    className: style.col6
  }, title && /*#__PURE__*/React.createElement(H3, {
    className: style.mb0
  }, title), /*#__PURE__*/React.createElement("div", {
    className: style.features
  }, customFeaturesUrl && /*#__PURE__*/React.createElement(RemoteJsonText, {
    url: customFeaturesUrl,
    style: style,
    linkColor: linkColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: style.col6
  }, /*#__PURE__*/React.createElement("div", {
    className: style.switch
  }, sortedMonthlyDonations.length && !onlyShowOneTimeDonations ? /*#__PURE__*/React.createElement("div", {
    className: classNames(style.switchItem, (_classNames3 = {}, _classNames3[style.active] = toggleState === 'month', _classNames3)),
    onClick: function onClick() {
      resetCustomPrice();
      changeToggleState('month');
    }
  }, "Monthly") : null, sortedYearlyDonations.length && !onlyShowOneTimeDonations ? /*#__PURE__*/React.createElement("div", {
    className: classNames(style.switchItem, (_classNames4 = {}, _classNames4[style.active] = toggleState === 'year', _classNames4)),
    onClick: function onClick() {
      resetCustomPrice();
      changeToggleState('year');
    }
  }, "Yearly") : null, sortedSingleDonations.length ? /*#__PURE__*/React.createElement("div", {
    className: classNames(style.switchItem, (_classNames5 = {}, _classNames5[style.active] = toggleState === 'single-donation' || onlyShowOneTimeDonations, _classNames5)),
    onClick: function onClick() {
      resetCustomPrice();
      changeToggleState('single-donation');
    }
  }, "One-Time") : null), toggleState === 'month' && mapDonations({
    donationsArray: sortedMonthlyDonations,
    donationChoice: monthlyDonationChoice,
    setDonationChoice: setMonthlyDonationChoice,
    donationName: 'month',
    changeCustomPrice: setMonthlyDonationCustomPrice
  }), toggleState === 'year' && mapDonations({
    donationsArray: sortedYearlyDonations,
    donationChoice: yearlyDonationChoice,
    setDonationChoice: setYearlyDonationChoice,
    donationName: 'year',
    changeCustomPrice: setYearlyDonationCustomPrice
  }), toggleState === 'single-donation' && mapDonations({
    donationsArray: sortedSingleDonations,
    donationChoice: singleDonationChoice,
    setDonationChoice: setSingleDonationChoice,
    donationName: 'single-donation',
    changeCustomPrice: setSingleDonationCustomPrice
  }), /*#__PURE__*/React.createElement(Field, _extends({
    name: 'submit',
    component: function component(props) {
      return /*#__PURE__*/React.createElement("button", _extends({
        type: "submit"
      }, props, {
        disabled: !intendedChoice.amount,
        className: classNames('btn', style.btn)
      }), contributionLanguage === 'tip' ? 'Tip' : 'Donate');
    },
    type: "submit",
    value: "test",
    onClick: function onClick(e) {
      e.preventDefault();
      var productOptionId = intendedChoice.id;
      var customPriceNormalized = intendedChoice.amount;
      var defaultOptionAmount = intendedChoice.defaultOptionAmount;
      var submissionPayload = {};
      if (productOptionId) {
        submissionPayload.productOptionId = productOptionId;
      }
      if (!defaultOptionAmount && customPriceNormalized) {
        submissionPayload.customPrice = customPriceNormalized;
      }
      if (submissionPayload.customPrice) {
        setCustomPrice(submissionPayload.customPrice);
      } else {
        setCustomPrice(null);
      }
      if (submissionPayload.productOptionId) {
        setProductOptionId(submissionPayload.productOptionId);
      }
    }
  }, rest))))));
};

export { SelectDonation as default };
//# sourceMappingURL=index.js.map
